<template>
  <div>
    <div class="page-wrapper-table">
      <div class="page-wrapper-table-header">
        <el-select
          class="select-primary pagination-select"
          v-model="pagination.perPage"
          :placeholder="$t('COMMON.PER_PAGE')"
        >
          <el-option
            class="select-primary"
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
        <organization-selector
          v-if="
            !filterOrganization &&
            $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)
          "
          @organizationChanged="
            (organizationId) => (selectedOrganization = organizationId)
          "
        />
      <!-- <base-input 
        v-if="$currentUserCan($permissions.PERM_VIEW_ANY_CUSTOMERS)"
      >
        <customer-selector
          :allowNone="true"
          :filterable="true"
          :showAll="false"
          :filterOrganization="selectedOrganization"
          :disabled="!selectedOrganization"
          @customerChanged="
            (customerId, customer) => {
              selectedCustomer = customerId
            }
          "
        />
      </base-input> -->
        <el-select
          class="select-primary pagination-select"
          v-model="selectedEntityType"
          :placeholder="$t('SYNC_LOGS.ENTITY_TYPE')"
          clearable
        >
          <el-option
            v-for="entityType in entityTypes"
            :key="entityType"
            :label="$t('SYNC_LOGS.ENTITY_TYPE_' + entityType)"
            :value="entityType"
          />
        </el-select>
        <el-select
          class="select-primary pagination-select"
          v-model="selectedAction"
          :placeholder="$t('SYNC_LOGS.ACTION')"
          clearable
        >
          <el-option
            v-for="action in actions"
            :key="action"
            :label="$t('SYNC_LOGS.ACTION_' + action)"
            :value="action"
          />
        </el-select>
        <el-select
          class="select-primary pagination-select"
          v-model="selectedStatus"
          :placeholder="$t('SYNC_LOGS.STATUS')"
          clearable
        >
          <el-option
            v-for="status in syncStatuses"
            :key="status"
            :label="$t('SYNC_LOGS.SYNC_STATUS_' + status)"
            :value="status"
          />
        </el-select>
        <base-input
          v-model="query"
          type="search"
          prepend-icon="fas fa-search"
          :placeholder="$t('COMMON.SEARCH')"
          clearable
        />
        <base-button
          class="btn base-button notification bg-dark btn-icon btn-fab btn-info btn-sm mb-4"
          icon
          size="sm"
          @click="resetFilters"
        >
          <span class="btn-inner--icon">
            <i class="fa fa-undo"></i>
          </span>
        </base-button>
      </div>
      <div class="page-wrapper-table-body">
        <div class="page-wrapper-table-body-inner">
          <el-table
            class="align-items-center table-flush"
            header-row-class-name="thead-light"
            :data="syncLogs"
            @sort-change="sortChange"
          >
            <div class="table-loading" slot="empty" v-if="loading">
              <img src="/img/loading.gif" />
            </div>
            
            <el-table-column min-width="90px">
              <template v-slot="{ row }">
                <img
                  v-if="servicesLogos[row.service_type]"
                  :src="servicesLogos[row.service_type]"
                  class="avatar rounded-circle mr-3"
                />
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('COMMON.CODE')"
              prop="code"
              sortable="custom"
              min-width="150"
            >
              <template v-slot="{ row }">
                <span>
                  {{ row.code ?? "" }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('SYNC_LOGS.ENTITY_TYPE')"
              prop="entity_type"
              min-width="200"
            >
              <template v-slot="{ row }">
                <span class="text-uppercase">
                  {{ $t("SYNC_LOGS.ENTITY_TYPE_" + row.entity_type) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('SYNC_LOGS.ACTION')" min-width="200">
              <template v-slot="{ row }">
                <sync-badge
                  class="mr-3 p-2 text-uppercase rounded-status-tag"
                  :status="row?.action"
                  :text="$t('SYNC_LOGS.ACTION_' + row?.action)"
                />
              </template>
            </el-table-column>
            <el-table-column :label="$t('SYNC_LOGS.STATUS')" min-width="200">
              <template v-slot="{ row }">
                  <sync-badge
                    class="mr-3 p-2 text-uppercase rounded-status-tag"
                    :status="row?.status"
                    :text="$t('SYNC_LOGS.SYNC_STATUS_' + row?.status)"
                  />
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('COMMON.ORGANIZATION')"
              v-if="
                !filterOrganization &&
                $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)
              "
              min-width="200"
            >
              <template v-slot="{ row }">
                <organization :organization="row.organization" />
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('COMMON.CREATED_AT')"
              prop="created_at"
              sortable="custom"
              min-width="220"
            >
              <template v-slot="{ row }">
                {{ $formatDate(row.created_at) }}
              </template>
            </el-table-column>
            <el-table-column fixed="right" min-width="120">
              <div slot-scope="{ row }" class="table-actions">
                <el-tooltip
                  :content="$t('COMMON.VIEW')"
                  placement="top"
                  v-if="$currentUserCan($permissions.PERM_VIEW_SYNC_LOGS)"
                >
                  <a
                    type="text"
                    @click="viewSyncLog(row)"
                    class="table-action"
                    data-toggle="tooltip"
                    style="cursor: pointer"
                  >
                    <i class="fal fa-expand-alt"></i>
                  </a>
                </el-tooltip>
                <!-- <el-tooltip
                  :content="$t('COMMON.EDIT')"
                  placement="top"
                  v-if="$currentUserCan($permissions.PERM_EDIT_SYNC_LOGS)"
                >
                  <a
                    type="text"
                    @click="editSyncLog(row)"
                    class="table-action table-action-delete"
                    data-toggle="tooltip"
                    style="cursor: pointer"
                  >
                    <i class="fal fa-edit"></i>
                  </a>
                </el-tooltip> -->
                <el-tooltip
                  :content="$t('COMMON.DELETE')"
                  placement="top"
                  v-if="$currentUserCan($permissions.PERM_DELETE_SYNC_LOGS)"
                >
                  <a
                    type="text"
                    @click="deleteSyncLog(row.id)"
                    class="table-action table-action-delete"
                    data-toggle="tooltip"
                    style="cursor: pointer"
                  >
                    <i class="fal fa-trash-alt"></i>
                  </a>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="page-wrapper-table-footer">
        <p class="card-category">
          {{
            $t("COMMON.DISPLAY_FROM_X_TO_X_OF_X_ENTRIES", {
              from: total ? from + 1 : 0,
              to: to,
              of: total,
            })
          }}
          <span v-if="selectedRows.length">
            &nbsp; &nbsp;
            {{ $t("COMMON.X_LINES_SELECTED", { count: selectedRows.length }) }}
          </span>
        </p>
        <base-pagination
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
        />
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Option,
  Select,
  Table,
  TableColumn,
  Tooltip,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { BasePagination } from "@/components";
import OrganizationSelector from "@/components/OrganizationSelector.vue";
import CustomerSelector from "@/components/CustomerSelector.vue";
import SyncBadge from "../components/SyncBadge.vue";
import {
  SERVICES_LOGOS,
} from "@/constants/thirdPartyServices";
import {
  ENTITY_TYPES,
  ACTIONS,
  SYNC_STATUS,
} from "@/constants/syncLogs";

export default {
  name: "sync-log-list-table",

  components: {
    BasePagination,
    OrganizationSelector,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    SyncBadge
  },

  mixins: [requestErrorMixin],

  props: {
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    filterSyncLogableType: {
      type: String,
      default: null,
      description: "SyncLogable class",
    },
    filterSyncLogableId: {
      type: String,
      default: null,
      description: "SyncLogable id",
    },
  },

  data() {
    return {
      query: null,
      selectedRows: [],
      sort: "-created_at",
      total: 0,
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [20, 50, 100, 500],
      },
      syncLogs: [],
      loading: true,
      selectedOrganization: null,
      selectedCustomer: null,
      selectedLocations: null,
      selectedTags: [],
      selectedEntityType: null,
      selectedAction: null,
      selectedStatus: null,
      entityTypes: ENTITY_TYPES,
      actions: ACTIONS,
      syncStatuses: SYNC_STATUS,
      servicesLogos: SERVICES_LOGOS
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
    filterOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedCustomer: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedTags: {
      handler: "getListDebounced",
      immediate: true,
    },
    filterSyncLogableType: {
      handler: "getListDebounced",
      immediate: true,
    },
    filterSyncLogableId: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedLocations: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedEntityType: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedAction: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedStatus: {
      handler: "getListDebounced",
      immediate: true,
    },
  },

  methods: {
    resetFilters() {
      this.selectedLocations = null;
      this.selectedOrganization = null;
      this.selectedCustomer = null;
      this.query = null;
      this.selectedTags = null;
      this.selectedEntityType = null;
      this.selectedAction = null;
      this.selectedStatus = null;
    },

    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      try {
        this.loading = true;
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.query ? { search: this.query } : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
          include: "organization",
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: { ...params.filter, organization: this.filterOrganization },
          };
        }
        if (this.selectedOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.selectedOrganization,
            },
          };
        }
        if (this.selectedEntityType) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              entity_type: this.selectedEntityType,
            },
          };
        }
        if (this.selectedAction) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              action: this.selectedAction,
            },
          };
        }
        if (this.selectedStatus) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              status: this.selectedStatus,
            },
          };
        }
        await this.$store.dispatch("syncLogs/list", params);
        this.syncLogs = this.$store.getters["syncLogs/list"];
        this.total = this.$store.getters["syncLogs/listTotal"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    editSyncLog(customer) {
      this.$emit("onEditSyncLog", customer);
      /* this.$router.push({
        name: "Edit Customer",
        params: { id: row.id },
      }); */
    },

    async deleteSyncLog(id) {
      const confirmation = await swal.fire({
        title: this.$t("SYNC_LOGS.DELETE_THIS_SYNC_LOG"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch("syncLogs/destroy", id);
          await this.getList();
          this.$notify({
            type: "success",
            message: this.$t("SYNC_LOGS.SYNC_LOG_DELETED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    viewSyncLog(syncLog) {
      this.$emit("onViewSyncLog", syncLog);
    },

    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },
  },
};
</script>
